import newFaqs from './newFaqs';
export const oldFaqs = [
    {
        q: 'Apa yang dimaksud dengan Akun Pembelajaran?',
        a: `  <p>Akun Pembelajaran adalah akun elektronik yang memuat nama akun (<span class="italic">user ID</span>) dan akses masuk akun (<span class="italic">password</span>) yang diterbitkan oleh Kemdikbudristek dan dapat digunakan oleh peserta didik, pendidik, dan tenaga kependidikan sebagai akun untuk mengakses aplikasi pembelajaran berbasis elektronik.</p>
      <p>Akun Pembelajaran bertujuan untuk mendukung kegiatan belajar, baik Belajar Dari Rumah maupun pembelajaran tatap muka, melalui penerapan teknologi informasi dan komunikasi.</p>
      <p>Akun Pembelajaran dibuat dalam bentuk akun Google dengan domain @belajar.id.</p>
      <p>Penggunaan Akun Pembelajaran bebas biaya.</p>
    `,
        featured: false,
    },
    {
        q: 'Siapa saja yang mendapatkan Akun Pembelajaran?',
        a: `  <ul>
        <li>Peserta Didik, meliputi:
          <ul>
            <li>SD dan Program Paket A kelas 5 dan kelas 6;</li>
            <li>SMP dan Program Paket B kelas 7 sampai dengan kelas 9;</li>
            <li>SMA dan Program Paket C kelas 10 sampai dengan kelas 12;</li>
            <li>SMK kelas 10 sampai dengan kelas 13;</li>
            <li>SLB kelas 5 sampai dengan kelas 12;</li>
            </ul>
          </li>
        <li>Pendidik pada jenjang pendidikan dasar dan menengah</li>
        <li>Tenaga Kependidikan pada jenjang pendidikan dasar dan menengah, meliputi:
          <ul>
            <li>Kepala Satuan Pendidikan (Kepala Sekolah)</li>
            <li>Operator Satuan Pendidikan (Operator Sekolah) yang terdata di Data Pokok Pendidikan (Dapodik).</li>
          </ul>
        </li>
      </ul>
    `,
        featured: false,
    },
    {
        q: 'Bagaimana cara mengakses Akun Pembelajaran?',
        a: `  Pendistribusian Akun Pembelajaran dilakukan dengan tata cara sebagai berikut:
      <ol>
        <li>
          Operator Satuan Pendidikan masuk ke laman
          <a href="http://pd.data.kemdikbud.go.id">pd.data.kemdikbud.go.id</a>
          lalu
          <span class="italic">login</span>;
        </li>
        <li>
          setelah masuk laman tersebut, Operator Satuan Pendidikan memilih tombol "**Unduh Akun**" untuk mengunduh dokumen CSV yang berisi daftar nama akun (<span class="italic">user ID</span>) dan akses masuk akun (<span class="italic">password</span>) Akun Pembelajaran di satuan pendidikan yang bersangkutan; dan</li>
        <li>Operator Satuan Pendidikan mendistribusikan Akun Pembelajaran tersebut kepada setiap pengguna Akun Pembelajaran di satuan pendidikan yang bersangkutan.</li>
      </ol>

      Pengaktifan Akun Pembelajaran dilakukan dengan tata cara sebagai berikut:
      <ol>
        <li>
          masuk laman <a href="https://mail.google.com">mail.google.com</a>;
        </li>
        <li>
          mengakses Akun Pembelajaran sesuai dengan nama akun (<span class="italic">user ID</span>) dan akses masuk akun (<span class="italic">password</span>) Akun Pembelajaran yang diterima;
        </li>
        <li>menyetujui syarat dan ketentuan penggunaan Akun Pembelajaran; dan</li>
        <li>melakukan penggantian akses masuk akun (<span class="italic">password</span>) Akun Pembelajaran.</li>
      </ol>
    `,
        featured: false,
    },
    {
        q: 'Bagaimana cara menggunakan Akun Pembelajaran?',
        a: `  <p>
        Setelah pendidik dan peserta didik melakukan aktivasi Akun Pembelajaran, akun tersebut dapat langsung digunakan untuk mengakses aplikasi-aplikasi yang tersedia dalam G Suite for Education (seperti Google Classroom, Google Drive, Google Docs, Google Sheets, Gmail, dan Google Calendar) serta aplikasi pembelajaran lainnya. Daftar aplikasi pembelajaran yang dapat diakses menggunakan Akun Pembelajaran tercantum pada laman <a href="https://belajar.id">www.belajar.id</a>.
      </p>
      <p>
        Struktur Akun Pembelajaran dalam Google Classroom telah disusun berdasarkan struktur rombongan belajar pendidik dan peserta didik di masing-masing satuan pendidikan, sehingga dapat langsung digunakan.
      </p>
    `,
        featured: false,
    },
    {
        q: 'Mengapa Akun Pembelajaran dibuat dalam bentuk akun Google?',
        a: `<ol>
      <li>Pembuatan Akun Pembelajaran dalam bentuk akun Google berarti pengguna otomatis mendapatkan akses ke aplikasi-aplikasi pendukung pembelajaran dalam G Suite for Education yang siap pakai dan telah banyak digunakan publik.</li>
      <li>Pembuatan dan penggunaan Akun Pembelajaran bebas biaya;</li>
      <li>Penggunaan aplikasi-aplikasi pendukung pembelajaran dalam G Suite for Education bebas biaya;</li>
      <li>Sistem Google mampu mengelola puluhan juta akun sekaligus dengan keamanan tingkat tinggi; dan</li>
      <li>Walaupun Akun Pembelajaran dibuat dalam bentuk akun Google, akun yang sama dapat digunakan untuk mengakses aplikasi Kemdikbudristek, serta berbagai aplikasi pembelajaran lainnya di luar ekosistem Google. Daftar aplikasi pembelajaran yang dapat diakses menggunakan Akun Pembelajaran tercantum pada laman <a href="https://belajar.id">www.belajar.id</a>.</li>
    </ol>
    `,
        featured: false,
    },
    {
        q: 'Apakah Akun Pembelajaran selamanya harus berbentuk akun Google?',
        a: `  <p>Tidak. Di kemudian hari Kementerian Pendidikan dan Kebudayaan dapat memutuskan untuk menggunakan sistem lain untuk Akun Pembelajaran.</p>
    `,
        featured: false,
    },
    {
        q: 'Apakah karena Akun Pembelajaran berbentuk akun Google, maka pengguna tidak bisa mengakses aplikasi perusahaan lain?',
        a: `  <p>
        Walaupun Akun Pembelajaran dibuat dalam bentuk akun Google, akun yang sama dapat digunakan untuk mengakses aplikasi Kemdikbudristek, serta berbagai aplikasi pembelajaran lainnya di luar ekosistem Google. Daftar aplikasi pembelajaran yang dapat diakses menggunakan Akun Pembelajaran tercantum pada laman
        <a href="https://www.belajar.id">
          www.belajar.id.
        </a>
      </p>
    `,
        featured: false,
    },
    {
        q: 'Mengapa Akun Pembelajaran menggunakan domain @belajar.id?',
        a: `  <p>
        @belajar.id merupakan nama domain yang dipilih Kementerian Pendidikan dan Kebudayaan atas dasar kemudahan diingat oleh pengguna Akun Pembelajaran serta kesesuaian dengan esensi dari pendidikan itu sendiri.
      </p>
    `,
        featured: true,
    },
    {
        q: 'Bagaimana perlindungan data terhadap data pendidik dan peserta didik yang digunakan untuk membuat Akun Pembelajaran?',
        a: `  <p>
        Keamanan Akun Pembelajaran diatur sesuai dengan ketentuan peraturan perundang-undangan dalam rangka memberikan perlindungan terhadap:
      </p>
      <ol>
        <li>kerahasiaan data, informasi, dan/atau dokumen aktivitas Akun Pembelajaran; dan</li>
        <li>kemungkinan terjadinya kelalaian dalam penggunaan dan/atau penyalahgunaan data, informasi, dan/atau dokumen aktivitas Akun Pembelajaran.</li>
      </ol>
      <p>
        Sesuai dengan Syarat dan Ketentuan G Suite for Education, data aktivitas pengguna akun G Suite for Education tidak digunakan untuk kepentingan komersil.
      </p>
    `,
        featured: true,
    },
    {
        q: 'Apakah penggunaan Akun Pembelajaran diwajibkan?',
        a: `  <p>
        Tidak, penggunaan Akun Pembelajaran bersifat opsional.
      </p>
      <p>
        Kemdikbudristek menyarankan peserta didik, pendidik, serta tenaga kependidikan untuk menggunakan Akun Pembelajaran karena:
      </p>
      <ol>
        <li>Akun Pembelajaran akan menjadi salah satu jalur komunikasi resmi Kemdikbudristek ke peserta didik, pendidik, dan tenaga kependidikan;</li>
        <li>Akun Pembelajaran akan digunakan untuk mengakses aplikasi-aplikasi resmi Kemdikbudristek; dan</li>
        <li>Materi dan informasi dari Kemdikbudristek, misalnya terkait bantuan pemerintah dan Asesmen Nasional, akan dikirimkan ke alamat pos elektronik Akun Pembelajaran.</li>
      </ol>
    `,
        featured: true,
    },
    {
        q: 'Apakah penggunaan Akun Pembelajaran menjadi persyaratan untuk menerima bantuan Teknologi Informasi dan Komunikasi (TIK) dari Kemdikbudristek?',
        a: `  <p>
        Tidak, penggunaan Akun Pembelajaran tidak menjadi persyaratan untuk menerima bantuan TIK dari Kemdikbudristek.
      </p>
    `,
        featured: true,
    },
    {
        q: 'Jika saya sudah memiliki akun Google pribadi, apa yang harus saya lakukan?',
        a: `  <p>
        Pendidik dan peserta didik bebas memutuskan jika ingin tetap menggunakan akun Google pribadinya, atau beralih ke Akun Pembelajaran dengan domain @belajar.id, atau menggunakan kedua akun tersebut.
      </p>
      <p>
        Kemdikbudristek menyarankan peserta didik, pendidik, serta tenaga kependidikan untuk menggunakan Akun Pembelajaran karena:
      </p>
      <ol>
        <li>Akun Pembelajaran akan menjadi salah satu jalur komunikasi resmi Kemdikbudristek ke pendidik dan peserta didik;</li>
        <li>Akun Pembelajaran akan digunakan untuk mengakses aplikasi-aplikasi resmi Kemdikbudristek; dan</li>
        <li>Materi dan informasi dari Kemdikbudristek, misalnya terkait bantuan pemerintah dan Asesmen Nasional, akan dikirimkan ke alamat pos elektronik Akun Pembelajaran.</li>
      </ol>
      <p>
        Pendidik dan peserta didik dapat melakukan migrasi data dari akun Google yang sebelumnya sudah digunakan untuk kegiatan belajar mengajar ke Akun Pembelajaran. Untuk melihat petunjuk cara migrasi data, klik
        <a href="https://belajardimanasaja.refoindonesia.com/30-hari-pertama-akun-belajar-id#h.2en180bm51yk">di sini</a>.
        Migrasi data tidak diwajibkan.
      </p>
    `,
        featured: true,
    },
];
export default newFaqs;
